import $ from 'jquery';

$(function () {
  if ($('.rewards-votes table').length) {
    $.fn.dataTable.ext.search.push(function (settings, data) {
      var checkbox = $('.show-deactivated-checkbox');
      var showDeactivated = checkbox.prop('checked');

      if (showDeactivated) {
        return true;
      }
      return data[data.length - 1] === 'true'; // the last column is "active? true/false"
    });

    $('.show-deactivated-checkbox').change(function () {
      $('.rewards-votes-table').DataTable().draw();
    });

    $('.rewards-votes-table').DataTable().draw();
  }
});
